import { FeaturedEvent } from '@insided/destination/modules/Navigation/widget-featured-topics/types'
import { Context } from '../server-middleware/context'

export interface Event {
  id: string
  title: string
  content: string
  startDate: string
  endDate: string
  location: string
  url: string
  image: string
  createdAt: string
  trashed: boolean
}

export default class UserAPI {
  url: string
  context: Context
  cache: {[eventId: number|string]: Event | undefined}

  constructor (context: Context) {
    this.context = context
    this.cache = {}
    const host = process.env.app_config_community_api_url
    this.url = host || 'http://api.dev.insided.com'
  }

  public async getEvent (eventId: string|number): Promise<Event> {
    const cached = this.cache[eventId]
    if (cached) return cached

    const url = `${this.url}/v2/events/${eventId}`
    const res = await this.context.axios.get(url, {
      headers: { 'X-Consumer-Custom-Id': this.context.yipId }
    })
    this.cache[eventId] = res.data.result
    return res.data
  }

  public async getEventsIndexedByIds (eventIds: Array<string|number>): Promise<Record<string, FeaturedEvent|undefined>> {
    const context = this.context
    function isFullfilled<T> (p: PromiseSettledResult<T>): p is PromiseFulfilledResult<T> {
      if (p.status === 'rejected') context.logger(p.reason)
      return p.status === 'fulfilled'
    }

    const events = (await Promise.allSettled(eventIds.map(async id => {
      const event = await this.getEvent(id)
      return {
        id: event.id,
        title: event.title,
        url: '/events/' + event.id,
        startsAt: (new Date(event.startDate)).getTime() / 1000,
        endsAt: (new Date(event.endDate)).getTime() / 1000,
        image: event.image,
        lastActivityAt: event.startDate,
        location: event.location,
        contentType: 'event' as const,
        isLoggedInUserAttendee: false
      }
    }))).filter(isFullfilled).map(p => p.value)

    const eventsMappedById: Record<string, FeaturedEvent|undefined> = {}
    events.forEach(event => {
      eventsMappedById[event.id] = event
    })

    return eventsMappedById
  }
}
